export const DEEP_LINK = {
  APP_STORE: 'https://apps.apple.com/us/app/capichi-delivery/id1554424185',
  GOOGLE_PLAY: 'https://capichideliveryapp.app.link',
  APP: 'capichidelivery://',
}
